'use strict';

const { getDependencyClass } = require('../../lib/dependencies.js');

getDependencyClass('phoenix-page').then((pageClass) => {
    class QuoteMediaSectorPerformance extends pageClass.PhoenixElement {
        connectedCallback() {
            super.connectedCallback();
            this._render();
        }

        _render() {
            const qModParams = {
                lang: 'en',
                upColor: '#008000',
                downColor: '#ff0000',
                indexGroup: 'ETF US',
            };

            this.innerHTML = `
                <div
                    data-qmod-tool='sectorperformance'
                    data-qmod-params='${JSON.stringify(qModParams)}'
                    class='qtool'
                >
                </div>
            `;
        }
    }

    window.customElements.define('phoenix-quote-media-sector-performance', QuoteMediaSectorPerformance);
});
